var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDarkMode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#F6F6F6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7797 18.45C9.01403 18.45 6.65913 16.981 5.65089 14.7916C5.99893 14.8599 6.4003 14.9306 6.75044 14.9306C10.4403 14.9306 13.4367 12.0659 13.4367 8.42062C13.4367 7.42218 13.2802 6.5536 12.8354 5.57523C16.0573 6.04665 18.45 8.80345 18.45 11.9589C18.45 15.4821 15.5003 18.45 11.7797 18.45Z",
    stroke: "#475467",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkMode);
export default __webpack_public_path__ + "static/media/dark-mode.bca20760206b64067557c86ed60d351d.svg";
export { ForwardRef as ReactComponent };